const TheModule = () => import("./TheModule.vue");
const TheWorks = () => import("./views/TheWorks.vue");
const TheWork = () => import("./views/TheWork.vue");

const moduleRoute = {
  path: "/works",
  component: TheModule,
  meta: {
    requiresAuthenticated: true
  },
  children: [
    {
      path: "/",
      component: TheWorks,
      meta: {
        requiresAuthenticated: true,
        // hide: true
      }
    },
    {
      path: ":id",
      props: true,
      component: TheWork,
      meta: {
        requiresAuthenticated: true,
        // hide: true
      }
    },

  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
